import DefaultButton from '@/components/common/default/DefaultButton';
import { PrimaryButton } from '@/components/common/PrimaryButton';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { OnBoardingModalStepOneProps } from '@/types/props/components/modals';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { ModalsEnum } from '@/types/translations/ModalsEnum';

export default function OnBoardingModalStepOne({
  handleNextStep,
  handleOnlySkip,
  handleSkipAndFinish,
}: OnBoardingModalStepOneProps) {
  const { translate } = useTypedTranslation<ModalsEnum>('modals');
  return (
    <>
      <p className="tw-font-plusJakartaSans tw-text-3xl tw-font-bold tw-text-white tw-leading-[40.32px] max-nine:tw-text-xl max-nine:tw-text-center max-nine:tw-mx-auto">
        {translate(ModalsEnum['onboarding_modal.welcome_to_spiritory'])}
      </p>
      <p className="tw-font-plusJakartaSans tw-font-medium tw-text-white tw-text-2xl tw-leading-[33.6px] max-nine:!tw-text-lg max-nine:tw-text-center max-nine:tw-mx-auto">
        {translate(ModalsEnum['onboarding_modal.content_step_one_1'])}
        <br />
        <br />
        {translate(ModalsEnum['onboarding_modal.content_step_one_2'])}
      </p>
      <div className="tw-flex tw-items-center tw-justify-end tw-gap-8 tw-mt-28">
        <div>
          <Menu>
            <MenuButton
              className="
            tw-font-bold tw-text-white 
            hover:tw-text-gray-300 
            focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-white/50 
            active:tw-text-gray-400 
            disabled:tw-opacity-50 disabled:tw-cursor-not-allowed
            tw-bg-transparent
            tw-border-none
            max-nine:tw-text-xs
            "
            >
              {translate(ModalsEnum['onboarding_modal.skip'])}
            </MenuButton>

            <MenuItems
              transition
              anchor="bottom end"
              className="tw-w-52 tw-origin-top-right tw-rounded-xl tw-border tw-border-gray-300 tw-bg-white tw-p-1 tw-text-sm tw-text-gray-800 tw-shadow-lg tw-transition tw-duration-100 tw-ease-out tw-[--anchor-gap:var(--spacing-1)] focus:tw-outline-none data-[closed]:tw-scale-95 data-[closed]:tw-opacity-0"
            >
              <MenuItem>
                <DefaultButton
                  onClick={handleOnlySkip}
                  className="tw-group tw-flex tw-w-full tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-gray-200 tw-bg-white tw-py-2 tw-px-4 tw-text-left tw-text-gray-800 hover:tw-bg-gray-100 hover:tw-border-gray-400 focus:tw-bg-gray-200 focus:tw-border-gray-500 max-nine:tw-text-xs"
                >
                  {translate(ModalsEnum['onboarding_modal.only_skip'])}
                </DefaultButton>
              </MenuItem>

              <div className="tw-my-1 tw-h-px tw-bg-gray-300" />

              <MenuItem>
                <DefaultButton
                  onClick={handleSkipAndFinish}
                  className="tw-group tw-flex tw-w-full tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-gray-200 tw-bg-white tw-py-2 tw-px-4 tw-text-left tw-text-gray-800 hover:tw-bg-gray-100 hover:tw-border-gray-400 focus:tw-bg-gray-200 focus:tw-border-gray-500 max-nine:tw-text-xs"
                >
                  {translate(
                    ModalsEnum['onboarding_modal.dont_show_me_this_again']
                  )}
                </DefaultButton>
              </MenuItem>
            </MenuItems>
          </Menu>
        </div>
        <PrimaryButton white={true} onClick={handleNextStep}>
          {translate(ModalsEnum['onboarding_modal.next'])}
        </PrimaryButton>
      </div>
    </>
  );
}
